import React from 'react';
import { Formik, Form, Field, withFormik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Yup from "yup";
import { withRouter } from 'react-router-dom';
import { Persist } from 'formik-persist';
import Camera, { IMAGE_TYPES } from 'react-html5-camera-photo';
import SignatureCanvas from 'react-signature-canvas'; // https://github.com/agilgur5/react-signature-canvas
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert, FormFeedback,
    Fade, ModalHeader
} from 'reactstrap';
import { bankValidationActions } from '../store/BcaValidation.Reducer';

class Page4Document extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            load: false,
            error: false,
            success: -1,
            message: 'Gagal Validasi',
            norek: localStorage.getItem('norek') || '',
            nama: localStorage.getItem('nama') || '',
            pilihBank: localStorage.getItem('pilihBank') || '',
            kepemilikanAsset: localStorage.getItem('kepemilikanAsset') || '1',
            validationCode: '',
            isLoading: false,
            openModal: false,
            PhotoKTP: localStorage.getItem('PhotoKTP') || '',
            signatureDataUrl: localStorage.getItem('signatureDataUrl') || '',
            signatureCanvasOpen: false,
            PhotoId: '',
            fotoSpecimen: '',
            imageHash: '', //Date.now(),
            trimmedDataURL: null,
            openModalPhoto: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.onSnapPhoto = this.onSnapPhoto.bind(this);
        this.takePhoto = this.takePhoto.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.imageChange = this.imageChange.bind(this);
    }

    Step1Schema = Yup.object().shape({

    });

    handleChange(event, setFieldValue) {
        const name = event.target.name;
        const value = event.target.value;
        setFieldValue(name, value);
        this.setState({ [name]: value });
        localStorage.setItem(name, value);

    }

    onSnapPhoto = (dataUri, setFieldValue) => {

        localStorage.setItem([this.state.PhotoId], dataUri);
        setFieldValue(this.state.PhotoId, dataUri);
        this.setState({ openModalPhoto: false });
    }

    handleSubmit = (values, { setSubmitting }) => {
        console.log('submit');
        localStorage.setItem('page', '-1');
        this.props.history.push('/register');
        setSubmitting(false);
    }

    openSignatureModal = () => {
        this.setState({ signatureCanvasOpen: true });
    }

    sigPad = () => { }

    imageChange = (e, setFieldValue) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        const componentName = e.target.name;

        reader.onloadend = () => {
            this.setState({
                [componentName]: reader.result
            });
            localStorage.setItem([componentName], reader.result);
        }
        setFieldValue(e.target.name, file);
        //localStorage.setItem([componentName], file);
        if (file != null) {
            reader.readAsDataURL(file);
        } else {
            this.setState({ imagePreviewUrl: '' });
        }
        //e.preventDefault();
        //let reader = new FileReader();
        //let file = e.target.files[0];
        //const componentName = e.target.name;

        //reader.onloadend = () => {
        //    this.setState({
        //        [componentName]: reader.result
        //    });
        //    localStorage.setItem([componentName], reader.result);
        //}
        //setFieldValue(e.target.name, file);
        //localStorage.setItem([componentName], file);
        //if (file != null) {
        //    reader.readAsDataURL(file);
        //}
    }

    clearSigPad = () => {
        this.sigPad.clear();
    }

    trim = (setFieldValue) => {
        if (this.sigPad.isEmpty()) {
            this.setState({ signatureDataUrl: '', signatureCanvasOpen: false });
            localStorage.setItem('signatureDataUrl', '');
        } else {
            this.setState({
                signatureDataUrl: this.sigPad.getTrimmedCanvas()
                    .toDataURL('image/png'), signatureCanvasOpen: false
            });
            localStorage.setItem('signatureDataUrl', this.sigPad.getTrimmedCanvas().toDataURL('image/png'));
            setFieldValue('SignatureImage', this.sigPad.getTrimmedCanvas()
                .toDataURL('image/png'));
        }
    }


    onPhotoKTPClick = (e) => {
        alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.' +
            '\n3. Pastikan posisi tulisan dapat dibaca dari kiri ke kanan, foto dan tanda tangan pada KTP harus terlihat jelas');
        return true;
    }

    takePhoto = (a, setFieldValue) => {
        if (a === 'PhotoSelfie') {
            alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.');
        }
        this.setState({ openModalPhoto: true, PhotoId: a });
    };

    render() {

        const { } = this.props;

        let msgAlert;

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <h2 className="py-3">Pendaftaran Nasabah</h2>

                   


                    <Fade in={true}>
                        <Formik
                            enableReinitialize
                            onSubmit={this.handleSubmit}
                        >
                            {({ errors, touched, values, isValid, setFieldValue, setFieldTouched }) => (

                                <Form autoComplete="off">

                                    <Modal isOpen={this.state.signatureCanvasOpen}>
                                        <SignatureCanvas penColor='black'
                                            canvasProps={{ width: 500, height: 500, className: 'sigCanvas', minWidth: 5 }}
                                            ref={(ref) => { this.sigPad = ref }} />
                                        <ModalFooter style={{ backgroundColor: '#f1f1f1' }}>
                                            <Button color="primary" onClick={() => this.trim(setFieldValue)}>Done</Button>{' '}
                                            <Button color="secondary" onClick={this.clearSigPad}>Clear</Button>
                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={this.state.openModalPhoto}>
                                        <Row>
                                            <Col md="12">
                                                < Camera
                                                    onTakePhoto={(dataUri) => { this.onSnapPhoto(dataUri, setFieldValue); }}
                                                    imageCompression={0}
                                                    isImageMirror={false}
                                                    isFullscreen={false}
                                                />
                                            </Col>
                                        </Row>
                                    </Modal>

                                    <FormGroup tag="fieldset">
                                        <legend>Dokumen Pendukung</legend>
                                        <Row>
                                            <Col md="6" xs="6">
                                                <FormGroup>
                                                    <Label>Foto KTP<span className="text-danger">*</span></Label>

                                                    <Input type="file" accept="image/*" id="PhotoKTP" name="PhotoKTP"
                                                        onClick={() => this.onPhotoKTPClick()}
                                                        onChange={(e) => this.imageChange(e, setFieldValue)} capture="camera"
                                                    />
                                                    {errors.PhotoKTP && touched.PhotoKTP ? (
                                                        <FormFeedback>{errors.PhotoKTP}</FormFeedback>
                                                    ) : null}
                                                    <img className="img-fluid" src={this.state.PhotoKTP} alt="" />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6" xs="6">
                                                <FormGroup>
                                                    <Label>Foto Selfie Pegang KTP<span className="text-danger">*</span></Label>
                                                    <br /><button type="button" className="btn btn-primary btn-sm" onClick={() => this.takePhoto('PhotoSelfieKTP', setFieldValue)}>Ambil Foto</button>

                                                    {errors.PhotoSelfieKTP && touched.PhotoSelfieKTP ? (
                                                        <FormFeedback>{errors.PhotoSelfieKTP}</FormFeedback>
                                                    ) : null}

                                                    <img src={values.PhotoSelfieKTP} alt="Captured" className="img-fluid" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6" xs="6">
                                                <FormGroup>
                                                    <Label>Tanda Tangan<span className="text-danger">*</span></Label>
                                                    <br />
                                                    <button type="button" className="btn btn-primary btn-sm"
                                                        onClick={() => this.openSignatureModal()}>Ambil Tanda Tangan</button>
                                                    <br />
                                                    {this.state.signatureDataUrl
                                                        ? <img alt="" className="img-fluid"
                                                            src={this.state.signatureDataUrl} />
                                                        : null}
                                                    {errors.SigatureImage && touched.SigatureImage ? (
                                                        <FormFeedback>{errors.SigatureImage}</FormFeedback>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <div className="row">
                                        <div className="col text-right">
                                            <Button
                                                type="submit"
                                                color="primary"
                                            >Lanjutkan &#8594;</Button>
                                        </div>
                                    </div>
                                    <Persist name="registrasi" />
                                </Form>
                            )}

                        </Formik>
                    </Fade>
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestBankValidation: bankValidationActions.requestBankValidation
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Page4Document);



// WEBPACK FOOTER //
// ./src/components/Page4Document.js